var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-md-row w-100 px-5"},[_c('Program',{ref:"program",on:{"loadPrograms":_vm.loadPrograms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }